module.exports = __webpack_public_path__ + "static/media/discover-evs-icon.c9c4b75b.svg";